const Dashboard = () => import('Views/dashboard/dashboard');
const DashboardNew = () => import('Views/dashboard/dashboard-new');

export default[
  { path: '/', component: Dashboard },
  { path: '/dashboard', component: Dashboard },
  { path: '/dashboard-new', component: DashboardNew },
];



// WEBPACK FOOTER //
// ./src/router/dashboard.js